<template>
  <div class="static-pages">
    <router-view />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'StaticPages',
});
</script>

<style scoped lang="scss">
.static-pages {
  width: 100%;
}
</style>
